import React from 'react';
import { getSelectedOption } from './commonRingUtils';
import { IPageData } from './Pages';
import { ITab, ITabs } from '../types/customizer';
import SwatchFilter from '../components/SwatchFilter';
import SizeFilter from '../components/SizeFilter';
import Summary from '../components/Summary';
import BoxFilter from '../components/BoxFilter';
import { getCategorizedOptions, getTypeOptions } from './basic';
import { getShapeItems } from './shapeItems';
import { getLogoItems } from './logoItems';
import { getV1FinishItems } from './finishItems';
import { getOutsideFeatureItems } from './outsideFeatureItems';
import { getSecondaryOutsideFeatureItems } from './secondaryOutsideFeatureItems';

export const getV4PageData = (props: IPageData) => {
    const { product: productData, ring_type, storeData, isBuildFromScratch, showCollegiateBands } = props;
    const product = { ...productData };
    product.categories = getCategorizedOptions(ring_type, storeData);
    product.types = getTypeOptions(ring_type, showCollegiateBands);

    const items: ITabs = [
        {
            title: 'Category',
            helzberg_key: 'category',
            eventKey: 'category',
            component: BoxFilter,
            isEnabled: true,
            isSelected: isBuildFromScratch,
            content: {
                hasSwatch: true,
                fieldType: 'category',
                options: product.categories,
                selectedOption: getSelectedOption(product.categories),
            },
        },
        {
            title: 'Type',
            helzberg_key: 'type',
            eventKey: 'type',
            component: BoxFilter,
            isEnabled: product.types.length > 0,
            content: {
                hasSwatch: true,
                fieldType: 'types',
                options: product.types,
                selectedOption: getSelectedOption(product.types),
            },
        },
        {
            title: 'Logo',
            helzberg_key: 'logo',
            eventKey: 'logo',
            items: getLogoItems(product),
            tabStyle: 'box',
            isSelected: !isBuildFromScratch,
        },
        {
            title: 'Shape',
            helzberg_key: 'shape',
            eventKey: 'shape',
            items: getShapeItems(product),
            tabStyle: 'box',
            isSelected: !isBuildFromScratch,
        },
        {
            title: 'Material',
            helzberg_key: 'material',
            eventKey: 'material',
            component: SwatchFilter,
            isEnabled: product.ring_material?.length > 0,
            content: {
                hasSwatch: true,
                fieldType: 'ring_materials',
                options: product.ring_material,
                selectedOption: getSelectedOption(product.ring_material),
            },
        },
        {
            title: 'Finish',
            helzberg_key: 'finish',
            eventKey: 'finish',
            items: getV1FinishItems(product),
            tabStyle: 'box',
        },
        {
            title: 'Outside Feature',
            helzberg_key: 'outside_feature',
            eventKey: 'outsideFeature_1',
            ...getOutsideFeatureItems(product),
            tabStyle: 'box',
        },
        {
            title: () => <>2<sup>nd</sup> Outside Feature</>,
            helzberg_key: 'outsideFeature_2',
            eventKey: 'outsideFeature_2',
            ...getSecondaryOutsideFeatureItems(product),
            tabStyle: 'box',
        },
        {
            title: 'Sleeves',
            helzberg_key: 'sleeve',
            eventKey: 'sleeve',
            component: SwatchFilter,
            isEnabled: product.sleeve?.length > 0,
            content: {
                hasSwatch: true,
                fieldType: 'sleeve',
                options: product.sleeve || [],
                selectedOption: getSelectedOption(product.sleeve),
            },
        },
        {
            title: 'Size',
            helzberg_key: 'size',
            eventKey: 'ringSize',
            component: SizeFilter,
            isEnabled: product.size?.length > 0,
            content: {
                hasSwatch: false,
                fieldType: 'size',
                options: product.size || [],
                selectedOption: getSelectedOption(product.size),
            },
        },
        {
            title: product.msrp ? ''  : 'Summary',
            helzberg_key: 'summary',
            eventKey: 'summary',
            component: Summary,
            isEnabled: true
        },
    ];

    const filtered = items.filter((tab: ITab) => tab.isEnabled || tab.items?.length);
    return filtered;
};